(() => {
  const storageKey = 'rawa-widget-dismissed';
  const dismissedClass = 'rawa-widget-dismissed';

  const wasDismissed = () => {
    try {
      return window.sessionStorage.getItem(storageKey) === 'true';
    } catch (_error) {
      return false;
    }
  };

  const dismissWidget = () => {
    document.documentElement.classList.add(dismissedClass);

    try {
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (_error) {
      // The CSS class still hides the widget when storage is unavailable.
    }
  };

  const addDismissButton = () => {
    const launcher = document.querySelector('#rawa-button');

    if (!launcher || launcher.querySelector('.rawa-widget-dismiss')) {
      return;
    }

    const button = document.createElement('button');
    button.className = 'rawa-widget-dismiss';
    button.type = 'button';
    button.setAttribute('aria-label', 'Chat ausblenden');
    button.title = 'Chat ausblenden';
    button.innerHTML = `
      <svg aria-hidden="true" viewBox="0 0 20 20" focusable="false">
        <path d="M11.414 10l6.293-6.293a1 1 0 1 0-1.414-1.414L10 8.586 3.707 2.293a1 1 0 0 0-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 1 0 1.414 1.414L10 11.414l6.293 6.293A1 1 0 0 0 17.707 16.293L11.414 10z" />
      </svg>
    `;

    button.addEventListener('pointerdown', (event) => event.stopPropagation());
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      dismissWidget();
    });

    launcher.appendChild(button);
  };

  if (wasDismissed()) {
    document.documentElement.classList.add(dismissedClass);
  }

  addDismissButton();

  const observer = new MutationObserver(addDismissButton);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
